<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "AgentInviteRecord",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'inviterUserId',
        placeholder: '上级(邀请人)ID',
        type: 'input',
      }, {
        name: 'inviteeUserId',
        placeholder: '下级(受邀人)ID',
        type: 'input',
      }],
      permission: {
        add: 'agentInviteRecord:add',
        update: 'agentInviteRecord:update',
        delete: 'agentInviteRecord:delete',
        deleteBatch: 'agentInviteRecord:deleteBatch'
      },
      url: {
        get: '/agentInviteRecord/listByCondition',
        add: '/agentInviteRecord/add',
        update: '/agentInviteRecord/update',
        delete: '/agentInviteRecord/delete/',
        delete_batch: '/agentInviteRecord/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '80',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '120',
      }, {
        field: 'inviterUserId',
        label: '邀请人ID',
        show: true,
        width: '120',
      }, {
        field: 'inviteeUserId',
        label: '被邀请人ID',
        show: true,
        width: '120',
      }, {
        field: 'inviteePhone',
        label: '被邀请人手机',
        show: true,
        width: '140',
      }, {
        field: 'inviteeName',
        label: '被邀请人昵称',
        show: true,
        width: '140',
      }, {
        field: 'status',
        label: '状态',
        show: {
          type: 'tag',
          tags: [{
            key: 'SUCCESS',
            value: '成功',
            type: 'success'
          }]
        },
        width: '100',
      }, {
        field: 'rechargePoints',
        label: '充值积分',
        show: true,
        width: '120',
      }, {
        field: 'firstRechargeOrderId',
        label: '首单编号',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '邀请时间',
        show: {
          type: 'datetime'
        },
        width: '160',
      }],
      operate: [],
      formFields: {
        addTitle: '补录邀请记录',
        updateTitle: '修改邀请记录',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择代理',
          add: true,
          update: true,
        }, {
          field: 'inviterUserId',
          label: '邀请人ID',
          type: 'textarea',
          rules: [{message: '请输入邀请人ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'inviteeUserId',
          label: '被邀人ID',
          type: 'textarea',
          rules: [{message: '请输入被邀请人ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'inviteePhone',
          label: '被邀人手机',
          type: 'textarea',
          add: true,
          update: true,
        }, {
          field: 'rechargePoints',
          label: '首次充值额',
          type: 'textarea',
          add: true,
          update: true,
        }, {
          field: 'status',
          label: '状态',
          type: 'textarea',
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>
